import { render, staticRenderFns } from "./AmbitiTicket.vue?vue&type=template&id=4812d185&scoped=true&"
import script from "./AmbitiTicket.vue?vue&type=script&lang=js&"
export * from "./AmbitiTicket.vue?vue&type=script&lang=js&"
import style0 from "./AmbitiTicket.vue?vue&type=style&index=0&id=4812d185&prod&scoped=true&lang=css&"
import style1 from "./AmbitiTicket.vue?vue&type=style&index=1&id=4812d185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812d185",
  null
  
)

export default component.exports